import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOptOutModalGraphic = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 116 215",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: -.35273,
			y: .35273,
			width: 109.536,
			height: 208.754,
			rx: 9.64727,
			transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 109.535 5.51221)",
			fill: "#4D4540",
			stroke: "#4D4540",
			strokeWidth: .705459
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -1,
			y: 1,
			width: 108.242,
			height: 207.459,
			rx: 9,
			transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 113.754 -8.74228e-08)",
			fill: "white",
			stroke: "#4D4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -.35273,
			y: .35273,
			width: 30.9194,
			height: 5.165,
			rx: 2.5825,
			transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 75.7438 7.35229)",
			fill: "#4D4540",
			stroke: "#4D4540",
			strokeWidth: .705459
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_1065_12722)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23.5316 83.2884C21.021 83.2977 18.9904 85.3404 18.9961 87.851L19.0643 118.11C19.0672 119.365 20.0871 120.379 21.3423 120.374L26.4252 120.355V125.881C26.4252 126.702 27.3596 127.173 28.0197 126.685L36.632 120.318L101.584 120.077C104.094 120.068 106.125 118.025 106.119 115.515L106.056 87.529C106.05 85.0184 104.01 82.9907 101.5 83L23.5316 83.2884Z",
				fill: "#FE5800"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.8654 107.18C47.9854 107.18 47.2354 107.02 46.6154 106.7C46.0054 106.38 45.4804 105.95 45.0404 105.41L46.2104 104.315C46.5804 104.765 46.9854 105.105 47.4254 105.335C47.8754 105.565 48.3854 105.68 48.9554 105.68C49.6254 105.68 50.1304 105.53 50.4704 105.23C50.8104 104.93 50.9804 104.525 50.9804 104.015C50.9804 103.605 50.8604 103.28 50.6204 103.04C50.3804 102.8 49.9554 102.62 49.3454 102.5L48.4154 102.335C47.3954 102.145 46.6304 101.81 46.1204 101.33C45.6104 100.85 45.3554 100.19 45.3554 99.35C45.3554 98.89 45.4404 98.475 45.6104 98.105C45.7904 97.725 46.0354 97.41 46.3454 97.16C46.6654 96.9 47.0504 96.7 47.5004 96.56C47.9504 96.42 48.4554 96.35 49.0154 96.35C49.8054 96.35 50.4904 96.49 51.0704 96.77C51.6504 97.04 52.1454 97.435 52.5554 97.955L51.3704 99.005C51.1004 98.655 50.7704 98.375 50.3804 98.165C49.9904 97.955 49.5054 97.85 48.9254 97.85C48.3254 97.85 47.8604 97.97 47.5304 98.21C47.2004 98.45 47.0354 98.8 47.0354 99.26C47.0354 99.7 47.1704 100.03 47.4404 100.25C47.7104 100.46 48.1304 100.62 48.7004 100.73L49.6304 100.925C50.6804 101.125 51.4454 101.465 51.9254 101.945C52.4154 102.425 52.6604 103.085 52.6604 103.925C52.6604 104.415 52.5754 104.86 52.4054 105.26C52.2354 105.66 51.9854 106.005 51.6554 106.295C51.3354 106.575 50.9404 106.795 50.4704 106.955C50.0004 107.105 49.4654 107.18 48.8654 107.18ZM58.3313 98.03V107H56.6363V98.03H53.5163V96.53H61.4513V98.03H58.3313ZM66.8166 107.18C66.1366 107.18 65.5166 107.065 64.9566 106.835C64.4066 106.595 63.9316 106.25 63.5316 105.8C63.1416 105.34 62.8366 104.775 62.6166 104.105C62.4066 103.425 62.3016 102.645 62.3016 101.765C62.3016 100.885 62.4066 100.11 62.6166 99.44C62.8366 98.76 63.1416 98.195 63.5316 97.745C63.9316 97.285 64.4066 96.94 64.9566 96.71C65.5166 96.47 66.1366 96.35 66.8166 96.35C67.4966 96.35 68.1116 96.47 68.6616 96.71C69.2216 96.94 69.6966 97.285 70.0866 97.745C70.4866 98.195 70.7916 98.76 71.0016 99.44C71.2216 100.11 71.3316 100.885 71.3316 101.765C71.3316 102.645 71.2216 103.425 71.0016 104.105C70.7916 104.775 70.4866 105.34 70.0866 105.8C69.6966 106.25 69.2216 106.595 68.6616 106.835C68.1116 107.065 67.4966 107.18 66.8166 107.18ZM66.8166 105.665C67.2166 105.665 67.5816 105.595 67.9116 105.455C68.2516 105.315 68.5366 105.115 68.7666 104.855C69.0066 104.585 69.1916 104.26 69.3216 103.88C69.4516 103.5 69.5166 103.07 69.5166 102.59V100.94C69.5166 100.46 69.4516 100.03 69.3216 99.65C69.1916 99.27 69.0066 98.95 68.7666 98.69C68.5366 98.42 68.2516 98.215 67.9116 98.075C67.5816 97.935 67.2166 97.865 66.8166 97.865C66.4066 97.865 66.0366 97.935 65.7066 98.075C65.3766 98.215 65.0916 98.42 64.8516 98.69C64.6216 98.95 64.4416 99.27 64.3116 99.65C64.1816 100.03 64.1166 100.46 64.1166 100.94V102.59C64.1166 103.07 64.1816 103.5 64.3116 103.88C64.4416 104.26 64.6216 104.585 64.8516 104.855C65.0916 105.115 65.3766 105.315 65.7066 105.455C66.0366 105.595 66.4066 105.665 66.8166 105.665ZM73.4453 107V96.53H77.9453C78.9153 96.53 79.6653 96.815 80.1953 97.385C80.7253 97.955 80.9903 98.72 80.9903 99.68C80.9903 100.64 80.7253 101.405 80.1953 101.975C79.6653 102.545 78.9153 102.83 77.9453 102.83H75.1403V107H73.4453ZM75.1403 101.345H77.8403C78.2703 101.345 78.6053 101.235 78.8453 101.015C79.0853 100.785 79.2053 100.46 79.2053 100.04V99.32C79.2053 98.9 79.0853 98.58 78.8453 98.36C78.6053 98.13 78.2703 98.015 77.8403 98.015H75.1403V101.345Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_1065_12722",
			x: 18.9961,
			y: 83,
			width: 87.123,
			height: 47.8831,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.996078 0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_1065_12722"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_1065_12722",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgOptOutModalGraphic;
